/**
 * Abstract Products Presenter
 */
class AbstractProductsPresenter {

	constructor() {

		/*
		 * Listeners
		 */

		/*
		 * Initialisation
		 */

	}

	/*
	 * Actions
	 */
	
}